import { z } from 'zod';

export const AudienceSizeOptions = [
  { value: 'under_1k', label: 'Under 1,000' },
  { value: '1k_10k', label: '1,000 - 10,000' },
  { value: '10k_50k', label: '10,000 - 50,000' },
  { value: '50k_100k', label: '50,000 - 100,000' },
  { value: '100k_plus', label: '100,000+' },
] as const;

export const NicheOptions = [
  { value: 'adult', label: 'Adult Content' },
  { value: 'dating', label: 'Dating & Relationships' },
  { value: 'lifestyle', label: 'Lifestyle' },
  { value: 'tech', label: 'Technology' },
  { value: 'influencer', label: 'Influencer/Creator' },
  { value: 'other', label: 'Other' },
] as const;

export const CountryOptions = [
  { value: 'US', label: 'United States' },
  { value: 'UK', label: 'United Kingdom' },
  { value: 'CA', label: 'Canada' },
  { value: 'AU', label: 'Australia' },
  { value: 'DE', label: 'Germany' },
  { value: 'FR', label: 'France' },
  { value: 'ES', label: 'Spain' },
  { value: 'IT', label: 'Italy' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'BR', label: 'Brazil' },
  { value: 'MX', label: 'Mexico' },
  { value: 'JP', label: 'Japan' },
  { value: 'KR', label: 'South Korea' },
  { value: 'IN', label: 'India' },
  { value: 'OTHER', label: 'Other' },
] as const;

export const SocialMediaLinkSchema = z.object({
  platform: z.string().min(1),
  url: z.string().url(),
});

export const AffiliateApplicationSchema = z.object({
  fullName: z
    .string()
    .min(2, 'Full name must be at least 2 characters')
    .max(100),
  email: z.string().email('Please enter a valid email address'),
  phone: z.string().optional(),
  country: z.string().min(1, 'Please select your country'),
  websiteUrl: z
    .string()
    .url('Please enter a valid URL')
    .optional()
    .or(z.literal('')),
  socialMediaLinks: z.array(SocialMediaLinkSchema),
  audienceSize: z.string().min(1, 'Please select your audience size'),
  niche: z.string().min(1, 'Please select your niche'),
  promotionMethods: z
    .string()
    .min(10, 'Please describe how you plan to promote (at least 10 characters)')
    .max(2000),
  whyJoin: z.string().max(2000).optional(),
  termsAccepted: z.boolean().refine((val) => val === true, {
    message: 'You must accept the terms and conditions',
  }),
});

export type AffiliateApplicationData = z.infer<
  typeof AffiliateApplicationSchema
>;
